import { render, staticRenderFns } from "./contrastSwitcherButton.vue?vue&type=template&id=f31e7308"
import script from "./contrastSwitcherButton.vue?vue&type=script&lang=js"
export * from "./contrastSwitcherButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports